import { Fragment } from "react";
import { FilterChip } from "../../filter-chip-group";
import type { OpenFilterArgs } from "../filters";
import type { LocalMaterialFilter, MaterialFilterType } from "../types";

export const PositionChipGroup = ({
  id,
  filter,
  hidden,
  ...props
}: {
  id: string;
  handleOpenFilter: (args: OpenFilterArgs<MaterialFilterType>) => void;
  handleDelete: (id: string) => void;
  filter?: {
    withCoordinates?: LocalMaterialFilter["withCoordinates"];
    withoutCoordinates?: LocalMaterialFilter["withoutCoordinates"];
  };
  hidden?: boolean;
}) => {
  const isPositioned = filter?.withCoordinates === true;
  const isNotPositioned = filter?.withoutCoordinates === true;

  return filter == null || hidden === true ? (
    <Fragment />
  ) : (
    <>
      {isPositioned && (
        <FilterChip
          filterLabel="Material"
          filterType="position"
          filterId={id}
          operation="is positioned"
          testIdPrefix="material-is-positioned"
          {...props}
        />
      )}
      {isNotPositioned && (
        <FilterChip
          filterLabel="Material"
          filterType="position"
          filterId={id}
          operation="is not positioned"
          testIdPrefix="material-is-not-positioned"
          {...props}
        />
      )}
    </>
  );
};
